<script setup lang="ts" generic="T extends Record<string, any>">
import { useDataTableWidget } from "../composables/useDataTableWidget";

defineProps<{
  table: ReturnType<typeof useDataTableWidget<T>>;
}>();
</script>

<template>
  <div class="flex mt-3">
    <div class="ml-auto">
      <n-pagination
        v-model:page="table.page.value"
        v-model:page-size="table.limit.value"
        :page-count="table.pageCount.value"
        :item-count="table.filteredTotal.value"
        show-size-picker
        :page-sizes="table.pageSizes"
        :prefix="table.paginationPrefix"
        @update:page="table.onPageChange"
        @update:page-size="table.onPageSizeChange"
        :page-slot="5"
      />
    </div>
  </div>
</template>
